import { Injectable } from '@angular/core';

@Injectable()
export class Educational {
    EducationalID:string;
    EducationalLevel:string;
    InstitutionName:string;
    EducationalName:string;
    Faculty:string;
    Branch:string;
    GPA:string;
    ApplyJobID:string;
}


// WEBPACK FOOTER //
// ./src/app/educational.ts